// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LDSS","controls":"styles_controls__z9njC","charLimit":"styles_charLimit__1MqRf","input":"styles_input__1i_hl","send":"styles_send__3Zhey"};